export function pct(num: number, den: number): number {
  if (den <= 0) return 0;
  return Math.round((num / den) * 100);
}

export function coverageColor(value: number): string {
  if (value >= 95) return "#059669";
  if (value >= 85) return "#10b981";
  if (value >= 70) return "#34d399";
  if (value >= 50) return "#fbbf24";
  if (value >= 30) return "#f59e0b";
  if (value >= 10) return "#f97316";
  return "#ef4444";
}

export function coverageBg(value: number): string {
  if (value >= 95) return "bg-emerald-50";
  if (value >= 85) return "bg-emerald-50/60";
  if (value >= 70) return "bg-green-50/40";
  if (value >= 50) return "bg-amber-50/40";
  if (value >= 30) return "bg-orange-50/40";
  return "bg-red-50/40";
}
